// action types
import { removeAnimationContainer, delay } from 'helpers';

export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_DESKTOP_SLIDER = 'TOGGLE_DESKTOP_SLIDER';

export const DATA_FETCHED = 'DATA_FETCHED';
export const CASES_FETCHED = 'CASES_FETCHED';
export const AGENCY_FETCHED = 'AGENCY_FETCHED';
export const REELS_FETCHED = 'REELS_FETCHED';

export const PAGE_READY = 'PAGE_READY';

export const OPEN_OVERLAY = 'OPEN_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';

export const LOGO_SCROLLED = 'LOGO_SCROLLED';

export const SCROLL_POSITION = 'SCROLL_POSITION';

export const CASE_TRANSITION_START = 'CASE_TRANSITION_START';
export const CASE_TRANSITION_END = 'CASE_TRANSITION_END';

export const HIDE_HEADER = 'HIDE_HEADER';
export const SHOW_HEADER = 'SHOW_HEADER';

export const SET_POPUP = 'SET_POPUP';
export const RESET_POPUP = 'RESET_POPUP';

export const SET_ACTIVE_SECTION = 'SET_ACTIVE_SECTION';
export const RESET_ACTIVE_SECTION = 'RESET_ACTIVE_SECTION';

export const SET_API_PATHS = 'SET_API_PATHS';

export const SET_MOBILE_AGENT = 'SET_MOBILE_AGENT';

export const SHOW_MOBILE_START_PAGE = 'SHOW_MOBILE_START_PAGE';
export const HIDE_MOBILE_START_PAGE = 'HIDE_MOBILE_START_PAGE';

export const SET_HOST = 'SET_HOST';
export const SET_URL = 'SET_URL';

export const toggleMenu = key => ({
  type: TOGGLE_MENU,
  key,
});

export const setApiPaths = payload => ({
  type: SET_API_PATHS,
  payload,
});

export const goToPage = (type, category) => ({
  type,
  payload: category && { category },
});

export const setPageReady = () => (dispatch, getState) => {
  const { overlay, pageReady } = getState();
  if (overlay) {
    delay(2000).then(() => dispatch(closeOverlay()));
  }
  removeAnimationContainer();
  if (pageReady) {
    return Promise.resolve();
  }
  dispatch({ type: PAGE_READY });
};

export const setPageReadyImmediately = () => (dispatch, getState) => {
  const { overlay, pageReady } = getState();
  if (overlay) {
    dispatch(closeOverlay());
  }
  removeAnimationContainer();
  if (pageReady) {
    return Promise.resolve();
  }
  dispatch({ type: PAGE_READY });
};

export const openOverlay = (color = 'transparent') => ({
  type: OPEN_OVERLAY,
  color,
});

export const setPopup = popup => (dispatch) => {
  const wrapper = document.getElementById('wrapper');

  if (wrapper) {
    wrapper.style.overflowY = 'hidden';
  }
  return dispatch({ type: SET_POPUP, payload: popup });
};
export const resetPopup = () => (dispatch) => {
  const wrapper = document.getElementById('wrapper');

  if (wrapper) {
    wrapper.style.overflowY = 'scroll';
  }
  return dispatch({ type: RESET_POPUP });
};

export const closeOverlay = () => ({
  type: CLOSE_OVERLAY,
});

export const logoHidden = isHidden => ({
  type: LOGO_SCROLLED,
  logoHidden: isHidden,
});


export const scrollPosition = (color, position, code = '') => (dispatch) => {
  try {
    if (location && code) {
      code = code.replace(/^#/, '');
      const node = document.querySelector(`#${code}`);
      if (node) {
        node.setAttribute('id', '');
      }

      if (location.hash !== '') {
        location.hash = code;
      }
      if (node) {
        node.setAttribute('id', code);
      }
    }

    if (!code) {
      location.hash = '';
    }
  } catch (error) {
    console.log(error);
  }

  dispatch({
    type: SCROLL_POSITION,
    scrollPosition: { color, position },
  });
};

export const setActiveSection = key => ({
  type: SET_ACTIVE_SECTION,
  payload: key,
});
export const resetActiveSection = () => ({
  type: RESET_ACTIVE_SECTION,
});

export const caseTransitionStart = () => ({
  type: CASE_TRANSITION_START,
});
export const caseTransitionEnd = () => ({
  type: CASE_TRANSITION_END,
});

export const setMobileAgent = agent => ({
  type: SET_MOBILE_AGENT,
  payload: agent,
});

export const hideMobileStartPage = () => ({
  type: HIDE_MOBILE_START_PAGE,
});
export const showMobileStartPage = () => ({
  type: SHOW_MOBILE_START_PAGE,
});

export const checkForMobileStartPage = req => async (dispatch, getState) => {
  const { mobileAgent } = getState();

  if (req.path === '/' && mobileAgent) {
    return dispatch(showMobileStartPage());
  }

  return Promise.resolve();
};


export const setHost = host => ({
  type: SET_HOST,
  payload: host,
});
export const setUrl = url => ({
  type: SET_URL,
  payload: url,
});



// WEBPACK FOOTER //
// ./src/actions/index.js